// Cookie / ad-tracking consent manager.
//
// - Persists the visitor's choice ("accepted" | "rejected") in localStorage.
// - Emits a `lmr:consent-change` DOM event so listeners (Meta Pixel, etc.)
//   can react without a full-page reload.
// - Defaults to "unknown" on first visit — the CookieConsentBanner shows
//   until the user makes a choice. Meta Pixel stays dormant until then,
//   which keeps us compliant with EU/UK ePrivacy rules and Meta's own
//   consent-mode requirements.

const KEY = "lmr:consent:marketing";

export function getConsent() {
  try {
    return localStorage.getItem(KEY) || null; // "accepted" | "rejected" | null
  } catch {
    return null;
  }
}

// India-first policy: tracking is ON by default and stops as soon as the
// visitor opts out. Personal details (email, phone, name, address) are only
// sent to ad platforms once the visitor has actively accepted.
export function trackingAllowed() {
  return getConsent() !== "rejected";
}

export function piiAllowed() {
  return getConsent() === "accepted";
}

export function hasMarketingConsent() {
  return getConsent() === "accepted";
}

export function setConsent(value /* "accepted" | "rejected" */) {
  try {
    localStorage.setItem(KEY, value);
  } catch {
    /* ignore quota / privacy-mode errors */
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent("lmr:consent-change", { detail: value }));
  }
}

export function onConsentChange(cb) {
  if (typeof window === "undefined") return () => {};
  const handler = (e) => cb(e.detail);
  window.addEventListener("lmr:consent-change", handler);
  return () => window.removeEventListener("lmr:consent-change", handler);
}
